export const FLAGS = ['loading', 'working', 'error'];

function notReady(o) {
  return FLAGS.some((f) => o[f]);
}

export default notReady;
